"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var url_helpers_1 = require("../../shared/url_helpers");
var date_utils_1 = require("../../../lib/date_utils");
var ShipOrderHeader = /** @class */ (function (_super) {
    tslib_1.__extends(ShipOrderHeader, _super);
    function ShipOrderHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShipOrderHeader.prototype.renderOrderNumber = function () {
        return (React.createElement("a", { href: url_helpers_1.default.orderPath({ orderId: this.props.orderId }) }, I18n.t('discovery.dashboard.selling.shipOrderViews.header.orderNumber', { orderId: this.props.orderId })));
    };
    ShipOrderHeader.prototype.renderOrderDate = function () {
        return (React.createElement("span", { className: "mlr-1 mobile-d-block mobile-margin-0" }, I18n.t('discovery.dashboard.selling.shipOrderViews.header.orderedDate', { date: date_utils_1.formatInternationalizedSeconds(this.props.orderCreatedAtSeconds) })));
    };
    ShipOrderHeader.prototype.renderBuyerName = function () {
        return (I18n.t('discovery.dashboard.selling.shipOrderViews.header.buyerName', { name: this.props.buyerName }));
    };
    ShipOrderHeader.prototype.renderShippingTips = function () {
        return (React.createElement(sanitized_render_1.default, { html: I18n.t('discovery.dashboard.selling.shipOrderViews.header.visitShippingGuide', { linkOpen: "<a href=" + url_helpers_1.default.shippingGuidePath + ">", linkClose: '</a>' }) }));
    };
    ShipOrderHeader.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h1", { className: "size-160 weight-bold" }, this.props.pageTitle),
            React.createElement("div", { className: "width-100 d-flex fx-justify-between mobile-size-90 mobile-d-block" },
                React.createElement("div", null,
                    this.renderOrderNumber(),
                    this.renderOrderDate(),
                    this.renderBuyerName()),
                this.renderShippingTips())));
    };
    return ShipOrderHeader;
}(React.Component));
exports.default = ShipOrderHeader;
//# sourceMappingURL=ship_order_header.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/shipping_labels/ship_order_header.js
// module id = 4ZaD
// module chunks = 20 21